
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {queryLabelInfos, updateLabelInfos} from "@/api/package";
import {Message} from "element-ui";

@Component({
  name: "labelInfo",
})
export default class extends Vue {
  @Prop({default: false}) private show: boolean;
  @Prop({default: "编辑贴标资料"}) private title: "";
  @Prop({default: ''}) private otherInfoId: {} | any;

  @Watch("show", {immediate: true})
  private watchData() {
    if (this.show) {
      this.getList();
    }
  }

  private infos: LabelInfo[] = [];
  private submitVisible = false;

  private async getList() {
    const data: any = await queryLabelInfos(this.otherInfoId);
    this.infos = data;
    this.infos.forEach(item => {
      item.edit = false
    })
  }

  private close() {
    this.$emit("success");
  }

  private multipleSelection: LabelInfo[];
  private canBatchDelete = true;

  private handleSelectionChange(selectedRecord: LabelInfo[]) {
    this.multipleSelection = selectedRecord;
    this.canBatchDelete = this.multipleSelection.length === 0;
  }

  private async submitForm(): Promise<void> {
    const existBlank = this.checkExistBlank();
    if (existBlank) {
      return;
    }
    let data = {
      otherInfoId: this.otherInfoId,
      req: this.infos
    }
    await updateLabelInfos(data)
    .then(() => {
      this.submitVisible = false;
      this.close();
    })
    .catch((err) => {
      this.submitVisible = false;
      console.log(err)
    });

  }

// 这里主要实现的功能是。一次只编辑一行记录。切换行关闭上一次行的编辑状态。再次点击编辑关闭本行编辑状态。
  private canEdit(row: LabelInfo) {
    if (row.edit) {
      const rowIndex = this.infos.indexOf(row);
      this.infos.splice(rowIndex, 1, {...row, edit: false});
    } else {
      this.infos.forEach(item => {
        item.edit = false;
      })
      row.edit = !row.edit;
      const rowIndex = this.infos.indexOf(row);
      this.infos.splice(rowIndex, 1, {...row, edit: true});
    }
  }

  private deleteRow(index: number) {
    this.infos.splice(index, 1);
  }

  // 批量删除的popver以及确定操作。
  private batchDeleteVisible = false;

  private batchDeleteRow() {
    this.multipleSelection.forEach((item) => {
      const index = this.infos.indexOf(item);
      this.infos.splice(index, 1);
    })
    this.batchDeleteVisible = false;
  }

// 实现的想法。增加行时，默认新增行可编辑，同时将之前可编辑行的状态更新为不可编辑
  private insertRow() {
    const existBlankTitle = this.checkExistBlank();
    if (existBlankTitle) {
      return;
    }
    // 主要是为了一次只编辑一行记录。
    this.infos.forEach(item => {
      item.edit = false;
    })
    this.infos.push(new LabelInfo(true));
  }

  private checkExistBlank() {
    let exist = false;
    this.infos.forEach(item => {
      if (!item.title || item.title.length === 0) {
        exist = true;
      }
      if (!item.content || item.content.length === 0) {
        exist = true;
      }
    })
    if (exist) {
      Message.error({
        message: "存在未填写内容的贴标表头/内容。请先填写",
        duration: 2000
      });
      return exist;
    }
  }
}

class LabelInfo {
  id: string;
  title: string;
  content: string;
  edit: boolean;

  constructor(edit: boolean) {
    this.edit = edit;
  }
}
